import axios from 'axios';
import ToastMsg from 'components/common/ToastMsg';
import { API_URL } from 'constants';

// Create an Axios instance
const apiClient = axios.create({
    baseURL: API_URL,
    timeout: 10000, // Request timeout
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add Authorization token
apiClient.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem('token');        
        if (token) {
            config.headers.Authorization = `token ${token}`;
        } else {
            // If no token, redirect to login page
            window.location.href = '/';
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to handle responses and errors
apiClient.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          ToastMsg("error", "Session expired. Please login again.");
          sessionStorage.clear()
          localStorage.clear()
          window.href = '/'
        } else {
          ToastMsg("error", error.response.data.message || "Error occurred.");
        }
      } else if (error.request) {
        ToastMsg("error", "Network error. Please check your connection.");
      } else {
        console.error('Error:', error.message);
      }
  
      return Promise.reject(error);
    }
  );
  

export default apiClient;